import * as React from 'react';
import * as screen1 from './style.module.scss';
import { HeaderLogoAndTel } from "../../../../../HeaderLogoAndTel";
import * as main from "../../../styles/main.module.scss";
export const Screen1krp = (
  {
    btnMainText="Получить курс",
    BtnMainAnchor="#cost",
    BtnSecText="Программа курса",
    BtnSecAnchor="#program",
    showUUtext=true,
    hideSecBtn=false,
    sravni=false
  }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        {
          sravni ?
            <HeaderLogoAndTel noLink={true}/>
            :
            <HeaderLogoAndTel/>
        }
        <div className={screen1.screen1__info}>
          { showUUtext && <span className={screen1.screen1__subtitle}>учись учиться для взрослых:</span>}
          <h1 className={screen1.screen1__title}>
            Курс развития памяти и&nbsp;внимания
          </h1>
          <div className={screen1.screen1__descriptionEl}>
            <p>
              Расскажем, как поддерживать свой мозг в&nbsp;активном состоянии, несмотря на возраст
            </p>
          </div>
          <div className={screen1.screen1__descriptionEl}>
            <p>
              Научим эффективным методикам запоминания информации
            </p>
          </div>
        </div>
        <a href={ BtnMainAnchor } className={main.mainBtnRound}>
          { btnMainText }
        </a>
        {
          !hideSecBtn &&
          <a href={ BtnSecAnchor } className={`${screen1.screen1__btn} ${main.mainBtnRound}`}>
            { BtnSecText }
          </a>
        }
      </div>
    </section>
  );
};
